import { Spinner } from "@chakra-ui/react";
import queryPayment from "../../services/payment/queryPayment";
import PropTypes from 'prop-types';
import { Elements } from "@stripe/react-stripe-js";
import StripeCheckoutForm from "./StripeCheckoutForm";
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE || '');

const FormCheckout = ({checkoutData, onSuccess, handleError}) => {
  /* RQ */
  const { data: dataPayment } = queryPayment().paymentStripeIntent(checkoutData?.id);
  const stripeClientSecret = dataPayment?.client_secret;
  const customerSessionClientSecret = dataPayment?.customer_session_client_secret;

  return !stripeClientSecret || !checkoutData?.id ? (
    <div className="flex flex-col gap-2 w-[340px] justify-center items-center text-blue-primary">
      <Spinner
        className="text-blue-primary"
        size={'lg'}
        thickness="5px"
      />
      <div className="text-2xl font-bold">Loading...</div>
    </div>
  ) : (
    <Elements
      options={{
        clientSecret: stripeClientSecret,
        ...(customerSessionClientSecret && { customerSessionClientSecret }),
        appearance: {
          theme: 'stripe',
        },
      }}
      stripe={stripePromise}
    >
      {/* Stripe form */}

      <StripeCheckoutForm
        checkout={checkoutData}
        setSuccess={onSuccess}
        setError={handleError}
      />
    </Elements>
  )
}

FormCheckout.propTypes = {
  checkoutData: PropTypes.object,
  onSuccess: PropTypes.func,
  handleError: PropTypes.func,
}

export default FormCheckout